import api from './api';

export interface IntranetNotification {
  id: string;
  title: string;
  message?: string;
  isRead: boolean;
  postId?: string;
  eventId?: string;
  userId: string;
  createdAt: string;
}

export const notificationsService = {
  async getAll(): Promise<IntranetNotification[]> {
    const response = await api.get('/notifications');
    return response.data;
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.count;
  },

  async markAsRead(id: string): Promise<IntranetNotification> {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/read-all');
  },
};
